import { render, staticRenderFns } from "./UserPropertyEdit.vue?vue&type=template&id=2258005a"
import script from "./UserPropertyEdit.vue?vue&type=script&lang=js"
export * from "./UserPropertyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports